import axiosV3 from '@/clientAPIV3.ts'
import * as types from './types'
import {MediaPackageFeedV3} from '@/features/feed/types'

//only creator
export const getMyMediaPackage = async (): Promise<types.MediaPackageV3[]> => {
    const {data} = await axiosV3.get(`/media-packages`)
    return data
}

export const createMediaPackage = async (body: types.MediaPackageCreateV3): Promise<types.MediaPackageV3> => {
    const {data} = await axiosV3.post(`/media-packages`, body)
    return data
}

export const getMediaPackageDetails = async ({
    mediaPackageId
}: {
    mediaPackageId: string
}): Promise<types.MediaPackageV3> => {
    const {data} = await axiosV3.get(`/media-packages/${mediaPackageId}`)
    return data
}

export const updateMediaPackage = async ({
    mediaPackageId,
    ...body
}: {
    mediaPackageId: string
    mediaPackagesContentsToDelete?: number[]
} & Partial<types.MediaPackageCreateV3>): Promise<types.MediaPackageV3> => {
    const {data} = await axiosV3.post(`/media-packages/${mediaPackageId}`, body)
    return data
}

export const removeMediaPackage = async ({mediaPackageId}: {mediaPackageId: string}) => {
    const {data} = await axiosV3.delete(`/media-packages/${mediaPackageId}`)
    return data
}

//only follower

export const getMediaPackagesListByCreator = async ({
    creatorId,
    ...params
}: {
    creatorId: string
    page?: number
    limit?: number
    responseType?: 'extended' | 'small'
}): Promise<types.ListMediaPackagesResponse> => {
    const {data} = await axiosV3.get(`/creators/${creatorId}/media-packages`, {params})
    return data
}

export const getMediaPackageDetailsByCreator = async ({
    creatorId,
    mediaPackageId
}: {
    creatorId: string
    mediaPackageId: string
}): Promise<types.MediaPackageV3> => {
    const {data} = await axiosV3.get(`/creators/${creatorId}/media-packages/${mediaPackageId}`)
    return data
}

export const unlockMediaPackage = async ({
    creatorId,
    mediaPackageId
}: {
    creatorId: string
    mediaPackageId: string
}): Promise<MediaPackageFeedV3> => {
    const {data} = await axiosV3.post(`/creators/${creatorId}/media-packages/${mediaPackageId}/unlock`)
    return data
}
